setTimeout(function(e){
  var advance = function advance() {
  
  }
  var infinitescroll = {
    scolljs: function(){
      var endlessScroll = new Ajaxinate({
        container: '#product-grid',
        pagination: '#AjaxinatePagination',
        loadingText: '',
        callback: advance,
        //offset: 200
      });
    }
  }
  infinitescroll.scolljs();
  document.addEventListener('wheel', function (e) {
    var totalpage = document.querySelector('#AjaxinatePagination a')?.dataset?.page ?? sessionStorage?.getItem('totalpage');
    sessionStorage.scrollPos = document.documentElement.scrollTop;
    sessionStorage.totalpage = totalpage;
  });
  if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {  	
    var scrollTop = sessionStorage?.getItem('scrollPos')
    window.scrollTo(0, 0);
    scrollManualy(scrollTop);
    function scrollManualy(scrollTop) {
    scrollTop = parseInt(scrollTop);
     const myTimeout = setTimeout(function () {
              if (window.scrollY < scrollTop && window.scrollY !== (scrollTop - 150)) {
                    window.scrollTo(0, scrollTop)
                    window.scrollTo(0, window.scrollY - 150)
                    clearTimeout(myTimeout);
                    scrollManualy(scrollTop)	
              }else{
                clearTimeout(myTimeout);
              }
          }, 1000);
      }
  }
  var currentColl = document.querySelectorAll('.seccolllist.active');
  if(document.querySelector('.seccolllist')){
    if(currentColl[0].nextElementSibling){
      var nextCollection = currentColl[0].nextElementSibling.dataset.title;
      var nextURL = currentColl[0].nextElementSibling.dataset.url;
      document.querySelector('.endcollection p').style.display = 'block';
      document.querySelector('.nextcollection').innerHTML = nextCollection;
      document.querySelector('.nextcollurl').href = nextURL;
    }else{
       document.querySelector('.endcollection p').style.display = 'none';
    }
  }
  $('body').on('click',function(e){   
    var seachbox = $(".snippet-collection-filter,.filterbutton");    
    if (!seachbox.is(e.target) && seachbox.has(e.target).length === 0){
      $('body').removeClass("open-filter");
    }
  });
  $(window).scroll(function(){
    var docViewTop = $(window).scrollTop();
    var docViewBottom = docViewTop + $(window).height();
    var elemTop = $('.section-footer').offset().top;
    if(elemTop < docViewBottom){      
      $('.section-collection').addClass('sticky_filter');
    }else{
      $('.section-collection').removeClass('sticky_filter');
    }
  });
},1000);